import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock, Mail, User } from "lucide-react";
import { TabsContent } from "../ui/tabs";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import auth from "@/shared/api/auth";
import { Link } from "react-router-dom";


export const RegisterTab = () => {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [registering, setRegistering] = useState();
    const [timer, setTimer] = useState(60);
    const [startTimer, setStartTimer] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (password !== confirmPassword) {
            toast.error("Пароли не совпадают");
        }

        if (name === "" || email === "" || password === "") {
            toast.error("Все поля обязательны");
        }

        try {
            await auth.signup(name, email, password);
            toast.success("Зарегистрировано успешно");
            setRegistering(email);
            setTimer(60);
            setStartTimer(true);
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        if (!startTimer) return; // если таймер не должен идти — выходим

        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setStartTimer(false);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => clearInterval(interval);
    }, [startTimer]);

    const handleResendVerification = async () => {
        try {
            await auth.resendVerification(email);
            toast.success("Письмо отправлено повторно");

            setTimer(60);        // сбросить счётчик
            setStartTimer(true); // запустить заново
        } catch (err) {
            console.error(err.message);
        }
    };

    const handleGoogleLogin = async () => {
        window.location = `${process.env.REACT_APP_BACKEND_URL}/api/auth/google`;
    }

    return (
        <TabsContent value="register">
            <form onSubmit={handleSubmit} className="space-y-4">
                {registering && (
                    <div>
                        Вам отправлено письмо с ссылкой для подтверждения регистрации на почту <strong>{registering}</strong>.
                        <br />
                        {timer > 0 ? (
                            <div className="text-muted-foreground">
                                Подождите {timer} секунд для повторной отправки письма.
                            </div>
                        ) : (
                            <div
                                className="text-muted-foreground underline cursor-pointer"
                                onClick={handleResendVerification}
                            >
                                Повторить отправку
                            </div>
                        )}
                    </div>
                )}

                <div className="space-y-2">
                    <Label htmlFor="register-name">Имя</Label>
                    <div className="relative">
                        <User className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                        <Input
                            id="register-name"
                            type="text"
                            placeholder="Ваше имя"
                            className="pl-10"
                            required
                            onChange={(e) => setName(e.target.value)}
                            value={name}
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="register-email">Email</Label>
                    <div className="relative">
                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                        <Input
                            id="register-email"
                            type="email"
                            placeholder="your@email.com"
                            className="pl-10"
                            required
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="register-password">Пароль</Label>
                    <div className="relative">
                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                        <Input
                            id="register-password"
                            type="password"
                            placeholder="••••••••"
                            className="pl-10"
                            required
                            onChange={(e) => setPassword(e.target.value)}
                            value={password}
                        />
                    </div>
                </div>

                <div className="space-y-2">
                    <Label htmlFor="register-confirm-password">Подтвердите пароль</Label>
                    <div className="relative">
                        <Lock className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
                        <Input
                            id="register-confirm-password"
                            type="password"
                            placeholder="••••••••"
                            className="pl-10"
                            required
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            value={confirmPassword}
                        />
                    </div>
                </div>

                <Button type="submit" className="w-full">
                    Создать аккаунт
                </Button>

                <div className="relative my-4">
                    <div className="absolute inset-0 flex items-center">
                        <span className="w-full border-t" />
                    </div>
                    <div className="relative flex justify-center">
                        <span className="bg-card px-2 text-muted-foreground">или</span>
                    </div>
                </div>

                <Button
                    type="button"
                    variant="outline"
                    className="w-full"
                    onClick={handleGoogleLogin}
                >
                    <svg className="mr-2 h-4 w-4" viewBox="0 0 24 24">
                        <path
                            d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                            fill="#4285F4"
                        />
                        <path
                            d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                            fill="#34A853"
                        />
                        <path
                            d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
                            fill="#FBBC05"
                        />
                        <path
                            d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                            fill="#EA4335"
                        />
                    </svg>
                    Зарегистрироваться через Google
                </Button>
            </form>
        </TabsContent>
    )
}